export type UserAuthState = {
    username:string,
    password:string,
    role:string,
    repeatPassword:string,
    isAuthenticated:boolean,
    user:UserAuth|null

}

export type UserAuth = {
    token?: JWTPayload
    error?: string
}

export type JWTPayload = {
    user_id:number
    username:string
    role_id:number,
    role:string
}

export const userAuth:UserAuthState={
    username:"",
    password:"",
    role:"",
    repeatPassword:"",
    isAuthenticated:false,
    user:null
}